import { IUploadConfig } from "src/types";

class UrlUtil {
    static goto(url: string, blank: boolean = false): void {
        if (url) {
            window.open(url, blank ? '_blank' : undefined)?.focus();
        }

    }

    static parseUrlUploadConfig(uploadConfig: IUploadConfig): string {
        const _port = uploadConfig.port === 80 ? "" : `:${uploadConfig.port}`
        return`//${uploadConfig.url}${_port}/`
    }
}

export { UrlUtil }